// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pagination_pagination__pages__McqIS {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.Pagination_pagination__page-link__2Ho2y {
  border-radius: 1rem;
  padding: 0.6rem 1.4rem;
  display: inline-block;
  background-color: var(--gray-semi-dark);
  color: #000;
  font-size: var(--text-sm);
  font-weight: 500;
}

.Pagination_pagination__page--active__rjC2n .Pagination_pagination__page-link__2Ho2y {
  background-color: var(--primary-color);
  color: #fff;
}

.Pagination_pagination__break-item-link__9\\+fL3 {
  color: #000;
  font-size: var(--text-sm);
  font-weight: 500;
}

.Pagination_pagination__arrow__OhTwl {
  width: 1.5rem;
  height: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pagination/Pagination.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,uCAAuC;EACvC,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB","sourcesContent":[".pagination__pages {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.pagination__page-link {\n  border-radius: 1rem;\n  padding: 0.6rem 1.4rem;\n  display: inline-block;\n  background-color: var(--gray-semi-dark);\n  color: #000;\n  font-size: var(--text-sm);\n  font-weight: 500;\n}\n\n.pagination__page--active .pagination__page-link {\n  background-color: var(--primary-color);\n  color: #fff;\n}\n\n.pagination__break-item-link {\n  color: #000;\n  font-size: var(--text-sm);\n  font-weight: 500;\n}\n\n.pagination__arrow {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination__pages": `Pagination_pagination__pages__McqIS`,
	"pagination__page-link": `Pagination_pagination__page-link__2Ho2y`,
	"pagination__page--active": `Pagination_pagination__page--active__rjC2n`,
	"pagination__break-item-link": `Pagination_pagination__break-item-link__9+fL3`,
	"pagination__arrow": `Pagination_pagination__arrow__OhTwl`
};
export default ___CSS_LOADER_EXPORT___;
